import { render, staticRenderFns } from "./TresGraficos.vue?vue&type=template&id=340ed3db&"
import script from "./TresGraficos.vue?vue&type=script&lang=js&"
export * from "./TresGraficos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports